export const trendsList = {
  HIGHER_GROWTH_TREND: 'HIGHER_GROWTH',
  MOST_WANTED_TREND: 'MOST_WANTED',
  MOST_POPULAR_TREND: 'MOST_POPULAR',
  MANUAL_TRENDS: 'MANUAL_TRENDS',
  CONSOLIDATED_TRENDS: 'CONSOLIDATED_TRENDS',
  OTHER_FILLED_TRENDS: 'OTHER_FILLED_TRENDS',
  BEST_SELLERS_POLYCARDS: 'BEST_SELLER_POLYCARDS',
  RECOMMENDED_ITEMS_POLYCARDS: 'RECOMMENDED_ITEMS_POLYCARDS',
};
